<template>
  <div class="fade-in interview">
    <div class="columns">
      <div class="column is-full">
        <h1 class="title">Interview Providers</h1>
      </div>
    </div>

    <table class="table is-responsive is-striped">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Link</th>
          <th>
            <router-link
              :to="{ name: 'interview-providers-create' }"
              class="button is-primary is-small is-pulled-right"
            >
              <i class="fa fa-plus"></i> Add Provider
            </router-link>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="row in Object.values(doctors)"
          :class="[{ deleted: row.attributes.deletedAt }]"
        >
          <td>{{ row.attributes.firstName }} {{ row.attributes.lastName }}</td>
          <td>{{ row.attributes.email }}</td>
          <td>{{ row.attributes.phone }}</td>
          <td>
            <a target="_blank" :href="scheduleUrl(row.attributes.shortCode)">{{
              scheduleUrl(row.attributes.shortCode)
            }}</a>
          </td>
          <td class="has-text-right">
            <span v-if="!row.attributes.deletedAt">
              <router-link
                :to="{
                  name: 'interview-providers-edit',
                  params: { id, doctorId: row.id }
                }"
              >
                <i class="fa fa-pencil"></i>
              </router-link>
              <a
                href="#"
                v-on:click.prevent="doctorDelete(row)"
                class="ml1"
                title="Delete"
                ><i class="fa fa-times"></i
              ></a>
            </span>
            <span v-if="row.attributes.deletedAt">
              <a
                href="#"
                v-on:click.prevent="reinstateDoctor(row)"
                class="ml1"
                title="Reinstate"
              >
                <i
                  :class="['fa', 'fa-refresh', { 'fa-spin': reinstateWorking }]"
                ></i>
              </a>
            </span>
          </td>
        </tr>
      </tbody>
    </table>

    <alert ref="alert" title="Confirm Delete" :onConfirm="onConfirm"
      >Are you sure you want to delete this provider?</alert
    >
  </div>
</template>

<script>
import InterviewsService from "@/services/InterviewsService";
import ReferralDoctorService from "@/services/ReferralDoctorService";
import alert from "@/components/alert";

export default {
  name: "interview-providers",

  props: ["id"],

  components: {
    alert
  },

  data() {
    return {
      log: {},
      loading: false,
      doctorId: null,
      reinstateWorking: false
    };
  },

  computed: {
    interview() {
      return this.$store.getters["interview/getById"](this.$props.id);
    },
    doctors() {
      return this.$store.getters["interview/doctors"];
    },
    practice() {
      return this.$store.getters["practice/current"];
    }
  },

  methods: {
    scheduleUrl(shortCode) {
      const keyword = this.interview.attributes.keyword;
      return `${InterviewsService.url(
        this.practice.subdomain,
        keyword
      )}/r/${shortCode}`;
    },
    load() {
      this.loading = true;
      InterviewsService.doctors(this.$props.id).then(() => {
        this.loading = false;
      });
    },
    doctorDelete(doctor) {
      this.$refs.alert.open();
      this.doctorId = doctor.id;
    },
    onConfirm() {
      ReferralDoctorService.delete(this.doctorId);
    },
    reinstateDoctor(doctor) {
      this.reinstateWorking = true;
      ReferralDoctorService.reinstate(doctor.id)
        .then(() => {
          this.reinstateWorking = false;
        })
        .catch(e => {
          this.reinstateWorking = false;
          console.log("error", e);
        });
    }
  },

  mounted() {
    this.load();
  }
};
</script>

<style lang="scss" scoped>
.deleted > td,
.deleted > td > a,
.deleted > td > i {
  /*background: #ff7675;*/
  text-decoration: line-through;
  color: #d63031;
}
</style>
